import { render, staticRenderFns } from "./MonitorTab.vue?vue&type=template&id=00a038f4&scoped=true"
import script from "./MonitorTab.vue?vue&type=script&lang=js"
export * from "./MonitorTab.vue?vue&type=script&lang=js"
import style0 from "./MonitorTab.vue?vue&type=style&index=0&id=00a038f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00a038f4",
  null
  
)

export default component.exports